<template>
  <div class="pt-3 bg-white">
    <!-- Header  -->
    <pc-my-project-header
      @editProject="editProject"
      :projectDetails="projectDetails"
      :onClickHandler="handleCreateNewProject"
      :projectId="trayId"
      :userRole="userRole"
    />
    <!-- Hero banner -->
    <pc-my-project-hero-banner
      @editProject="editProject"
      :projectDetails="projectDetails"
      :userRole="userRole"
    />

    <div class="container">
      <div class="mt-5">
        <!-- Item component -->
        <pc-my-project-item
          :col="6"
          @editContent="editContent($event)"
          :projectDetails="projectDetails"
          @editColorImg="editColorImg($event)"
          :userRole="userRole"
        />
      </div>
      <!-- Bottom add item button -->
      <div class="row mt-5 mb-3 text-center" v-if="userRole">
        <div class="col-sm-12 mb-5 add-button">
          <add-item-button
            :onClickHandler="handleCreateNewProject"
            :buttonText="buttonText"
          ></add-item-button>
        </div>
      </div>
    </div>
    <modal
      height="650"
      name="project-wizard-content-modal"
      data-html2canvas-ignore="true"
      :adaptive="true"
      :projectId="trayId"
      class="my-project-modal"
      :scrollable="true"
    >
      <pc-project-wizard-content-modal
        :projectDetails="projectDetails"
        @closeModal="closeModal"
      ></pc-project-wizard-content-modal>
    </modal>

    <modal
      height="500"
      name="create-project-modal"
      data-html2canvas-ignore="true"
      :adaptive="true"
      :scrollable="true"
    >
      <pc-my-project-create-modal
        :projectId="trayId"
        :projectDetails="projectDetails"
        :isEdit="isEdit"
        :trayId="trayId"
        :adaptive="true"
      />
    </modal>
    <modal
      height="500"
      name="create-brand-project-modal"
      data-html2canvas-ignore="true"
      :adaptive="true"
      :scrollable="true"
    >
      <pc-my-project-brand-create-modal
        :projectId="trayId"
        :projectDetails="projectDetails"
        :isEdit="isEdit"
        :trayId="trayId"
        :adaptive="true"
      />
    </modal>
    <modal
      height="650"
      name="project-upload-image-modal"
      data-html2canvas-ignore="true"
      :adaptive="true"
    >
      <pc-project-upload-image-modal></pc-project-upload-image-modal>
    </modal>

    <modal
      height="400"
      name="project-edit-content-item-modal"
      data-html2canvas-ignore="true"
      :adaptive="true"
      :scrollable="true"
    >
      <pc-my-project-edit-content-item
        :projectID="projectDetails.boardDetails.id"
        :productData="productData"
      ></pc-my-project-edit-content-item>
    </modal>

    <modal
      height="500"
      name="project-edit-colors-feature-img-modal"
      data-html2canvas-ignore="true"
      :adaptive="true"
      :scrollable="true"
    >
      <pc-my-project-edit-colors-feature-img
        :projectDetails="projectDetails"
        :productData="productData"
      ></pc-my-project-edit-colors-feature-img>
    </modal>

    <modal
      height="450"
      name="share-project-modal"
      data-html2canvas-ignore="true"
      :adaptive="true"
      :scrollable="true"
    >
      <pc-share-project-modal
        :projectDetails="projectDetails"
        :productData="productData"
        :userRole="userRole"
        :isAdmin="isAdminUser"
        :userEmail="userEmail"
      ></pc-share-project-modal>
    </modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PcMyProjectItem from "./pc-my-project-item.vue";
import PcMyProjectHeader from "./pc-my-project-header.vue";
import PcMyProjectHeroBanner from "./pc-my-project-hero-banner.vue";
import pcProjectWizardContentModal from "../content-wizard-modal/pc-project-wizard-content-modal.vue";
import PcMyProjectCreateModal from "./pc-my-project-create-modal.vue";
import PcMyProjectBrandCreateModal from "./pc-my-project-brand-create-modal.vue";
import PcProjectUploadImageModal from "./pc-project-upload-image-modal.vue";
import PcMyProjectEditContentItem from "./pc-my-project-edit-content-item.vue";
import PcMyProjectEditColorsFeatureImg from "./pc-my-project-edit-colors-feature-img.vue";
import AddItemButton from "./my-project-add-button.vue";
import PcShareProjectModal from "./pc-share-project-modal.vue";

export default {
  props: ["user", "projectDetails"],
  components: {
    PcMyProjectItem,
    PcMyProjectHeader,
    PcMyProjectHeroBanner,
    pcProjectWizardContentModal,
    PcMyProjectCreateModal,
    PcMyProjectBrandCreateModal,
    PcProjectUploadImageModal,
    PcMyProjectEditContentItem,
    PcMyProjectEditColorsFeatureImg,
    AddItemButton,
    PcShareProjectModal,
  },
  mounted() {
    if (this.projectDetails.role != null) {
      this.isAdminUser = this.user?.isAdmin;
      this.userEmail = this.user?.user?.email;
      this.userRole = this.user?.isAdmin
        ? true
        : this.projectDetails?.role != 0 && this.projectDetails.role != null
        ? true
        : false;
    }
    this.updateCommonErrorMsg(this.$resourceString["common.Error.Msg"]);
    this.myProjectCommonErrorMsg(this.$resourceString["common.Error.Msg"]);
    this.commonErrorMsg(this.$resourceString["common.Error.Msg"]);
    this.basketTitleUpdate(this.$resourceString["virtualtray.basket.updated.title"]);
    this.basketCommonErrorMsg(this.$resourceString["common.CartAlert.ErrorMsg"]);
    this.setProjectDetails(this.projectDetails);
  },

  data() {
    return {
      projectUrl: "",
      projectId: "",
      isEdit: false,
      productData: "",
      trayId: null,
      buttonText: this.$resourceString["myProject.Project.EditPage.AddItem"],
      userRole: false,
      isAdminUser: false,
      userEmail: "",
    };
  },

  created() {
    const currentUrl = window.location.href;
    let urlParts = currentUrl.split("/");
    this.trayId = urlParts[urlParts.length - 1];
    if (urlParts.includes("Edit")) {
      this.trayId = urlParts[urlParts.length - 1];
      this.UpdatetrayEditId(this.trayId);
    } else {
      this.trayId = null;
      this.UpdatetrayEditId(this.trayId);
    }
  },

  methods: {
    ...mapActions({
      fetchProjectDetails: "myProject/fetchProjectDetails",
      UpdatetrayEditId: "myTray/UpdatetrayEditId",
      resetContent: "contentWizard/resetContent",
      updateCommonErrorMsg: "myTray/updateCommonErrorMsg",
      myProjectCommonErrorMsg: "myProject/myProjectCommonErrorMsg",
      basketTitleUpdate: "myProject/basketTitleUpdate",
      basketCommonErrorMsg: "myProject/basketCommonErrorMsg",
      commonErrorMsg: "contentWizard/commonErrorMsg",
      setProjectDetails: "contentWizard/setProjectDetails",
      setIsOutOfProject: "contentWizard/setIsOutOfProject",
    }),
    handleCreateNewProject() {
      this.showModal("project-wizard-content");
      this.resetContent();
      this.setIsOutOfProject(false);
    },
    closeModal() {
      this.$modal.hide("project-wizard-content-modal");
    },
    showModal(name) {
      this.$modal.show(name + "-modal");
    },
    editProject() {
      this.isEdit = true;
      if (
        this.projectDetails.type === "brand" ||
        this.projectDetails.boardDetails.brandBoard?.boardId !== null
      ) {
        this.showModal("create-brand-project");
      } else {
        this.showModal("create-project");
      }
    },
    editContent(value) {
      this.productData = value;
      this.showModal("project-edit-content-item");
    },
    editColorImg(value) {
      this.productData = value;
      this.showModal("project-edit-colors-feature-img");
    },
  },
};
</script>
